import { rootApi } from 'root-api'

/**
 * GET /api/users/me/jwt — returns JWTs for Intercom.
 * API returns secureMessengerToken (intercomUserToken) and userToken (userToken).
 */
const api = rootApi.injectEndpoints({
  endpoints: (build) => ({
    getUsersJwt: build.query({
      query: () => ({ url: '/users/me/jwt' }),
    }),
  }),
})

export const { useGetUsersJwtQuery } = api
